import { render } from "./IdealPaymentOption.vue?vue&type=template&id=676fa4fc"
import script from "./IdealPaymentOption.vue?vue&type=script&lang=js"
export * from "./IdealPaymentOption.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__